export const PANEL_MAX_HEIGHT_PX = 240;
export const PANEL_MIN_WIDTH_PX = 308;

export interface TriggerRect {
  top: number;
  left: number;
  right: number;
  bottom: number;
  width: number;
}

export interface PanelPosition {
  top: number;
  left: number;
  width: number;
  maxHeight: number;
}

export function calculateDirectoryIconPickerPanelPosition(
  triggerRect: TriggerRect,
  viewportWidth: number,
  viewportHeight: number,
  panelScrollHeight = PANEL_MAX_HEIGHT_PX
): PanelPosition {
  const panelHeight = Math.min(panelScrollHeight, PANEL_MAX_HEIGHT_PX);

  const spaceBelow = viewportHeight - triggerRect.bottom - 8;
  const spaceAbove = triggerRect.top - 8;

  let top: number;
  let maxHeight: number;
  if (spaceBelow >= panelHeight || spaceBelow >= spaceAbove) {
    top = triggerRect.bottom + 4;
    maxHeight = Math.min(PANEL_MAX_HEIGHT_PX, spaceBelow);
  } else {
    const availableAbove = Math.min(panelHeight, spaceAbove);
    top = Math.max(4, triggerRect.top - availableAbove - 4);
    maxHeight = Math.min(PANEL_MAX_HEIGHT_PX, spaceAbove);
  }

  const panelWidth = Math.max(PANEL_MIN_WIDTH_PX, triggerRect.width);
  let left = triggerRect.right - panelWidth;
  left = Math.max(8, left);
  if (left + panelWidth > viewportWidth - 8) {
    left = viewportWidth - panelWidth - 8;
  }

  return {
    top,
    left,
    width: panelWidth,
    maxHeight,
  };
}
